export default {
  downtimeUrl: "https://it.kodland.tech",
  startPage: {
    image: "/welcome/quiz_italy_copy.jpg",
    title: "Ti basta 1 min per ricevere l’invito a partecipare a una prima lezione gratuita",
    subtitle:
      "Tuo figlio/a creerà il suo primo progetto: un videogioco o un programma👾 Vi mostreremo come trascorrere il tempo al computer con beneficio🔥",
    button: "Clicca qui per ottenere la lezione 🎁",
  },
  successPage: {
    title:
      "Perfetto! Vi chiediamo di scegliere un orario comodo per voi, per prenotare la vostra GRATUITA lezione. Affrettatevi a confermare la vostra presenza per una lezione con un tutor altamente qualificato 🚀",
    subtitle: 'Clicca su "📆 Prenota una lezione" per completare la registrazione',
    button: "📆 Prenota una lezione",
  },
  quizRotateBySteps: {
    1: {
      question: "Quanto tempo trascorre tuo figlio/a passa con i gadget?",
      answers: ["⭐️ Oltre le 2 ore", "💝 Da 2 a 4 ore", "🔥 Più di 4 ore", "🤔 Non l'ho contato"],
    },
    2: {
      question: "Cosa pensi che potrebbe interessare tuo figlio/a?",
      answers: [
        "🕹 Sviluppo di videogiochi",
        "🎨 Web design",
        "👾 Design grafico",
        "🔮 Roblox",
        "🪩 Programmazione",
      ],
    },
    3: {
      question:
        "Com'è tuo figlio/a caratterialmente? La risposta ci aiuterà a trovare il tutor più adatto/a per tuo figlio/a 🤗",
      answers: [
        "😏 Attivo/a, ama socializzare",
        "😌 Timido/a, nella maggior parte dei casi",
        "🖖 Sognatore/sognatrice",
        "🏠 Tranquillo/a, trascorre la maggior parte del tempo a casa",
        "🤔 Indeciso/a, non sa bene cosa desidera",
        "🤓 Non rispondo per ora (preferisco dirvelo durante la lezione)",
      ],
    },
  },
};
